// Products available in DocSide
export const PRODUCTS = [
  {
    id: 'control-center',
    name: 'Control Center',
    description: 'Administrative control panel',
    color: 'linear-gradient(46deg, #223948 0%, #4639a2 100%)',
  },
  {
    id: 'mentor-portal',
    name: 'Mentor Portal',
    description: 'Therapist and doctor interface',
    color: 'linear-gradient(46deg, rgb(216, 101, 0) 0%, rgb(216, 101, 0) 100%)',
  },
  {
    id: 'aumhum-app',
    name: 'AUMHUM App',
    description: 'Consumer mobile application',
    color: 'linear-gradient(46deg, rgb(0, 43, 107) 0%, rgb(50, 0, 129) 100%)',
  },
  {
    id: 'assistant-portal',
    name: 'Assistant Portal',
    description: 'Clinic assistant interface',
    color: 'linear-gradient(46deg, rgb(17, 39, 71) 0%, rgb(198, 82, 67) 100%)',
  },
]

// Roles available for each product
export const ROLES = [
  {
    id: 'ROLE_CLINIC_ASSISTANT',
    name: 'Clinic Assistant',
    description: 'Clinic front desk and administrative staff',
    allowedProducts: ['assistant-portal', 'aumhum-app'],
  },
  {
    id: 'ROLE_TEACHER',
    name: 'Teacher/Therapist',
    description: 'Mental health therapists and counselors',
    allowedProducts: ['mentor-portal', 'aumhum-app'],
  },
  {
    id: 'ROLE_DOCTOR',
    name: 'Doctor',
    description: 'Medical doctors and psychiatrists',
    allowedProducts: ['mentor-portal', 'aumhum-app'],
  },
  {
    id: 'ROLE_PATIENT',
    name: 'Patient',
    description: 'End users seeking mental health services',
    allowedProducts: ['aumhum-app'],
  },
  {
    id: 'ROLE_CLINIC_OWNER',
    name: 'Clinic Owner',
    description: 'Clinic administrators and owners',
    allowedProducts: ['control-center', 'aumhum-app'],
  },
]

// Get roles for a specific product
export const getRolesForProduct = (productId) => {
  return ROLES.filter(role => role.allowedProducts.includes(productId))
}

// Get product by ID
export const getProductById = (productId) => {
  return PRODUCTS.find(product => product.id === productId)
}

// Get role by ID
export const getRoleById = (roleId) => {
  return ROLES.find(role => role.id === roleId)
}

// Content types for playable external content
export const CONTENT_TYPES = {
  PLAYLIST: 'playlist',
  SINGLE_VIDEO: 'single_video',
}

// Exclusion/Inclusion types
export const EXCL_INCL_TYPES = {
  EXCLUDE: 'exclude',
  INCLUDE: 'include',
} 